/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Map_HintInputs */

const vi_grower_map_hint = /** @type {(inputs: Grower_Map_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm bản đồ để thêm điểm · Kéo điểm để chỉnh`)
};

/**

* @param {Grower_Map_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_map_hint = /** @type {((inputs?: Grower_Map_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Map_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_map_hint(inputs)
});